export const CREATING_TESTIMONIAL = "CREATING_TESTIMONIAL";
export const UPDATING_TESTIMONIAL = "UPDATING_TESTIMONIAL";
export const TESTIMONIAL_CREATED = "TESTIMONIAL_CREATED";
export const TESTIMONIAL_UPDATED = "TESTIMONIAL_UPDATED";
export const ERROR_TESTIMONIAL_CREATE = "ERROR_TESTIMONIAL_CREATE";
export const ERROR_TESTIMONIAL_UPDATE = "ERROR_TESTIMONIAL_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
